import { selectFeatureFlags, selectUserRbacPermissions } from 'core/userContext';
import { useCampaignContext } from 'modules/campaigns/editor/context';
import { useSelector } from 'react-redux';
import { canManageMessagingByMedium } from 'utils/permissions';

export const useCampaignPermission = () => {
  const { UseChannelBasedPermissions } = useSelector(selectFeatureFlags);
  const userPermissions = useSelector(selectUserRbacPermissions) || [];

  const {
    campaign: { messageMedium },
  } = useCampaignContext();

  const hasManageMessagingAccess = canManageMessagingByMedium(
    userPermissions,
    messageMedium,
    UseChannelBasedPermissions,
  );

  return { hasManageMessagingAccess };
};
